module.exports = __webpack_public_path__ + "static/media/vloggi-logo-blue.d93e597d.png";